import type { SerializableTradingFormState } from '@server/trading-layouts/schemas';
import type { TradingFormState } from '@client/widgets/trading-form/trading-form.types';

// Layout snapshots now store the same self-contained form shape that the trading form uses,
// so saving a layout is a plain deep copy with no template resolution step.
export const formStateToLayoutState = (
  formState: TradingFormState
): SerializableTradingFormState => structuredClone(formState);

// Restoring a layout is the inverse operation: return a detached copy of the persisted form state.
export const layoutStateToFormState = (
  layoutState: SerializableTradingFormState
): TradingFormState => structuredClone(layoutState);

// The async helpers stay for compatibility with existing call sites, but they no longer need
// template catalogs because layout payloads are already self-contained.
export const resolveLayoutStateToFormState = async (
  _trpcClient: unknown,
  layoutState: SerializableTradingFormState
): Promise<TradingFormState> => layoutStateToFormState(layoutState);

export const resolveLayoutStatesToFormState = async (
  _trpcClient: unknown,
  layoutStates: SerializableTradingFormState[]
): Promise<TradingFormState[]> =>
  layoutStates.map((layoutState) => layoutStateToFormState(layoutState));
